module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_PL-6ad2a2609530c6d799e62f84ecd4c981.svg";